/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCameraAlt} from '@fortawesome/pro-duotone-svg-icons';

const PhotoIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCameraAlt} {...props} />
);

export default PhotoIcon;
